import { ASSETS_PATH } from '@/constants.ts'

export function assetPath(file) {
  return `${ASSETS_PATH}/${file}`
}
